import * as Actions from 'reducks/checkout/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const CheckoutReducer = (state = initialState.checkout, action: any) => {
  switch (action.type) {
    case Actions.COUNT_ORDER_TIMES:
      return {
        ...state,
        orderTimes: [...action.payload],
      }
    case Actions.FETCH_ORDERS:
      return {
        ...state,
        orders: [...action.payload],
      }
    case Actions.INIT_CHECKOUT:
      return {
        is_set_unsubscribe: false,
        orders: [],
        orderTimes: [],
        unsubscribes: [],
      }
    case Actions.INIT_CHECKOUT_UNSUBSCRIBES:
      return {
        ...state,
        is_set_unsubscribe: false,
        unsubscribes: [],
      }
    case Actions.SET_CHECKOUT_UNSUBSCRIBES:
      return {
        ...state,
        is_set_unsubscribe: true,
        unsubscribes: [...action.payload],
      }
    default:
      return state
  }
}
